export default __webpack_public_path__ + "static/media/ESSS30ROSE45.6797d8f3.mp4";